import Client from './Clients/ScrapingToolsClient'

const resource = '/operations/log/'

export default{
    get(operationLogId){
        return Client.get(resource+'?operation_log='+operationLogId);
    }
}